import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { App } from './App';
import { StorageProvider } from './utils/useLocalStorage';
import { AlertsProvider } from './utils/alert-channel';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { IsMobileProvider, ThemeProvider } from 'shared';
import React from 'react';
import './index.css';

const container = document.getElementById('root');

if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
	window.location.protocol = 'https:';
}

if (!container) {
	throw new Error('Root element not present! Please contact engineering!');
}

if (import.meta.env.VITE_SENTRY_RELEASE) {
	Sentry.init({
		dsn: 'https://aa44f0872f2d4d5d9f98f7fab09c663c@o4504645495357440.ingest.sentry.io/4504657879498752',
		tracesSampleRate: 1.0,
		// @ts-expect-error @sentry/tracing's BrowserTracing types lag @sentry/react's
    integrations: [new BrowserTracing({
			routingInstrumentation: Sentry.reactRouterV6Instrumentation(
				React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			),
		})],
		release: import.meta.env.VITE_SENTRY_RELEASE,
	});
}

const root = createRoot(container);
root.render(
	<ErrorBoundary>
    <ThemeProvider>
      <AlertsProvider>
        <IsMobileProvider>
          <StorageProvider>
            <App />
          </StorageProvider>
        </IsMobileProvider>
      </AlertsProvider>
    </ThemeProvider>
	</ErrorBoundary>,
);
